import React from 'react';
import styled, { css } from 'styled-components';
import { Icon } from '../';
import { IconBase } from '../Base';
const Wrapper = styled.div `
  --eye-line-background-color: #fff;
  position: relative;
  display: table;
  svg {
    path {
      transition:
        stroke 0.2s,
        fill 0.2s;
    }
  }
`;
const Line = styled(IconBase) `
  fill: none;
  stroke-dasharray: 20px;
  stroke-dashoffset: var(--eye-line-offset);
  transition: stroke-dashoffset 0.2s ease-out;
  position: absolute;
  left: 0;
  top: 0;

  ${({ line }) => line &&
    css `
      --eye-line-offset: 20px;
    `}
`;
export const IconEye = (props) => {
    return (React.createElement(Wrapper, { className: props.className },
        React.createElement(Icon.Eye, null),
        React.createElement(Line, { line: props.line },
            React.createElement("path", { d: "M16.85 5.8L5.79999 16.85", strokeWidth: "2.3", strokeLinecap: "round", style: { stroke: 'var(--eye-line-background-color)' } }),
            React.createElement("path", { d: "M15.5 4.5L4.5 15.5", strokeWidth: "1.5", strokeLinecap: "round", style: { stroke: 'var(--icon-color)' } }))));
};
//# sourceMappingURL=Eye.js.map